export default __webpack_public_path__ + "static/pete-9b8fb921b5b1b32efac05d9657e918a9.jpg";